// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Button, Group, Loader, Text } from '@mantine/core';
import { i18n } from '@lingui/core';
import { closeAllModals, openModal } from '@mantine/modals';
import { FC, ReactNode, useState } from 'react';

interface Props {
  title: string;
  description: ReactNode;
  onConfirm: () => Promise<boolean>;
  btnColor?: string;
  btnText?: string;
}

// eslint-disable-next-line import/prefer-default-export
export const openDeleteConfirmModal = (props: Props) => {
  openModal({
    title: (
      <Text weight="bolder" size="xl">
        {props.title}
      </Text>
    ),
    // eslint-disable-next-line react/jsx-props-no-spreading
    children: <ConfirmModal {...props} />,
  });
};

const ConfirmModal: FC<Props> = ({ title, description, onConfirm, btnColor = 'red', btnText = 'actions.delete' }) => {
  const [loading, setLoading] = useState(false);

  const onClick = async () => {
    setLoading(true);
    const deleted = await onConfirm();
    setLoading(false);
    if (deleted) {
      closeAllModals();
    }
  };

  return (
    <>
      <Text>{description}</Text>
      <Group position="right" spacing="xs" mt="xl">
        <Button color="gray" variant="subtle" onClick={() => closeAllModals()}>
          {i18n._('actions.cancel')}
        </Button>
        <Button
          disabled={loading}
          onClick={onClick}
          leftIcon={loading && <Loader size="xs" />}
          color={btnColor}
          variant="subtle"
          sx={{ backgroundColor: btnText === 'actions.delete' ? '#FFEFEF' : undefined }}
        >
          {i18n._(btnText)}
        </Button>
      </Group>
    </>
  );
};
